<template>
    <div class="footer">
        <div class="contact-data">
            <ul class="list-unstyled tel-data">
                <li>
                    <h4>商家咨询及电话验证请致电</h4>
                    <h4>400-660-1065</h4>
                    <p>周一到周日 09:00 - 21:00</p>
                </li>
                <li>
                    <h4>消费者咨询请致电</h4>
                    <h4>10107888</h4>
                    <p>周一到周日 09:00 - 22:00</p>
                </li>
                <li>
                    <h4>廉政邮箱</h4>
                    <h4>lianzheng@meituan.com</h4>
                    <p>周一到周日 09:00 - 21:00</p>
                </li>
            </ul>
        </div>
        <div class="copyright">
            <p>©
                <span>2017</span>
                <a class="unstyled" href="https://www.meituan.com/">美团网团购</a>
                meituan.com
                <a class="unstyled" href="http://www.beianbeian.com/beianxinxi/283f39a9-4c00-427a-97ef-3c7a9e1e0af1.html" target="_blank">京ICP证070791号</a>
                <span>版本:{{version}}</span>
            </p>
        </div>
        <ul class="footer-mark list-unstyled" ng-if="$ctrl.showMark">
            <li>
                <a class="footer-icon footer-icon-1" title="备案信息" href="http://www.meituan.com/about/openinfo" hidefocus="true" target="_blank"><img src="https://p0.meituan.net/codeman/c144939183a31861e666846fb5f711733601.png" /></a>
            </li>
            <li>
                <a class="footer-icon footer-icon-2" href="http://t.knet.cn/index_new.jsp" target="_blank" title="可信网站认证" rel="nofollow"><img src="https://p1.meituan.net/codeman/bd7c7958fd27346dac8802826b863e435343.png" /></a>
            </li>
            <li>
                <a class="footer-icon footer-icon-3" href="http://www.bj315.org/xfwq/lstd/201209/t20120910_3344.shtml?dnrpluojqxbceiqq" target="_blank" title="12315消费争议" rel="nofollow"><img src="https://p1.meituan.net/codeman/bdf473bd76b1eb3f73b71a57a3afaf962232.png"></a>
            </li>
        </ul>
    </div>
</template>

<style rel="stylesheet/css" lang="postcss" type="text/postcss">
.footer {
  background-color: #e9ecf2;
  padding-top: 20px;
  .contact-data {
    overflow: hidden;
    text-align: center;
    .tel-data {
      li {
        position: relative;
        text-align: left;
        display: inline-block;
        padding: 0 20px;
        h4 {
          font-size: 14px;
          font-weight: 400;
        }
        p {
          font-size: 12px;
          color: #666666;
        }
        &:after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -24px;
          display: inline-block;
          vertical-align: middle;
          height: 48px;
          border-left: 1px solid #ccd2df;
        }
        &:last-child:after {
          display: none;
        }
      }
    }
    .link-code {
      li {
        text-align: center;
        float: left;
        margin-left: 20px;
        p {
          line-height: 3;
          font-size: 12px;
        }
      }
    }
  }
  .copyright {
    clear: both;
    text-align: center;
    font-size: 12px;
    color: #333;
    line-height: 12px;
    margin: 5px 0;
  }
  .footer-mark {
    text-align: center;
    li {
      display: inline-block;
      padding: 4px;
    }
  }
}
</style>
<script type="text/babel">
    import { mapState } from "vuex";

    export default {
        name: "footerBar",
        computed: {
            ...mapState({
                version: state => state.version
            })
        }
    };
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// FooterBar.vue?ef517cc4